import { render } from "./CommunicatorDebug.vue?vue&type=template&id=4ea98cf7"
import script from "./CommunicatorDebug.vue?vue&type=script&lang=js"
export * from "./CommunicatorDebug.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/CommunicatorDebug.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ea98cf7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ea98cf7', __exports__)) {
    api.reload('4ea98cf7', __exports__)
  }
  
  module.hot.accept("./CommunicatorDebug.vue?vue&type=template&id=4ea98cf7", () => {
    api.rerender('4ea98cf7', render)
  })

}


export default __exports__